export const ROUTE_CREDIT_APP = 'ROUTE_CREDIT_APP';
export const ROUTE_CREDIT_RESULTS = 'ROUTE_CREDIT_RESULTS';
export const ROUTE_DEAL_SUMMARY = 'ROUTE_DEAL_SUMMARY';
export const ROUTE_TEST_DRIVE = 'ROUTE_TEST_DRIVE';
export const ROUTE_HOME = 'ROUTE_HOME';
export const ROUTE_BACK = 'ROUTE_BACK';

// credit app actions
export const LEAD_REFERENCE_TOKEN_REQUEST = 'LEAD_REFERENCE_TOKEN_REQUEST';
export const LEAD_REFERENCE_TOKEN_SUCCESS = 'LEAD_REFERENCE_TOKEN_SUCCESS';
export const LEAD_REFERENCE_TOKEN_FAILURE = 'LEAD_REFERENCE_TOKEN_FAILURE';
export const OFFER_SUBMISSION_SUCCESS = 'OFFER_SUBMISSION_SUCCESS';

export const UPDATE_CREDIT_APP = 'UPDATE_CREDIT_APP';
export const CANCEL_CREDIT_APP = 'CANCEL_CREDIT_APP';
